export const DASHBOARD_HEADER_SAVI_ENGAGEICON =
  'ispm-dashboard-header-saviEngageIcon';
export const DASHBOARD_HEADER_SAVI_RESUMEICON =
  'ispm-dashboard-header-saviResumeIcon';
export const DASHBOARD_HEADER_SAVI_INPUTBOX =
  'ispm-dashboard-header-saviInputBox';
export const CHATOVERLAY_HEADER_CLOSEICON = 'ispm-chatOverlay-header-closeIcon';
export const CHATOVERLAY_HEADER_RESETICON = 'ispm-chatOverlay-header-resetIcon';
export const DASHBOARD_BODY = 'ispm-dashboard-body';
export const SUGGESTIONS = 'ispm-suggestions';
export const DASHBOARD_LOADER = 'ispm-dashboard-loader';
export const TABLE_HEADER_TOOLTIP =
  'ispm-DataSectionHeader-detailedStepsTooltip';
export const CHART_SQL = 'ispm-ChartPanel-sql';
export const CHART_VISUALIZATION = 'ispm-ChartPanel-visualization';
export const TABLE_SQL = 'ispm-TabelPanel-sql';
export const TABLE_VISUALIZATION = 'ispm-TablePanel-visualization';
